import common from "../common";
import Button from "./Button";
import MiniSignal from 'mini-signals';

export default class DropDownInput extends Button
{
    constructor(label, id, options, selectedOption, css = {})
    {
        /*
        if(css.height == undefined)
            css.height = '12%';
        if(css.width == undefined)
            css.width = '30%';*/

        super(css);

        this.signals.focusIn = new MiniSignal();
        this.signals.focusOut = new MiniSignal();

        this.closedHeight = css.height;
        this.openHeight = '50%';
        this.isOpen = false;

        this.selectedOption = selectedOption;

        this.border = null;

        this.currentValue = null;

        this.addBacking();
        this.initDropDown(label, id, options);
    }

    addBacking()
    {
        /*this.border = $('<div class="p3-borderedContent"></div>');
        this.htmlElement.append(this.border);*/
    }

    initDropDown(label, id, options)
    {
        this.type = Button.TYPE_DROP_DOWN_INPUT;

        this.htmlElement.css('minWidth', 'auto');
        this.htmlElement.css('minHeight', 'auto');

        this.formElement = $('<select class="p3-dropDown" id="' + id + '" name="' + label + '" style="text-align:left"></select>');

        console.log('SELECTED OPTION', this.selectedOption)
        for(var i in options)
        {
            if(options[i].regionalDifferences && options[i].regionalDifferences[common.country])
            {
                for(var j in options[i].regionalDifferences[common.country])
                {
                    options[i][j] = options[i].regionalDifferences[common.country][j];
                }
            }
            var option = $('<option value="' + options[i].value + '">' + options[i].name + '</option>');
            this.formElement.append(option);
            if(String(options[i].value) == String(this.selectedOption))
            {
                option.attr('selected', 'selected');
            }
        }
        this.htmlElement.append(this.formElement);

        this.formElement.on("click change", this.onFieldSelect.bind(this));
        this.formElement.on("change", this.onFieldChange.bind(this));
        this.formElement.focusin((event) => this.onFieldFocusIn(event));
        this.formElement.focusout((event) => this.onFieldFocusOut(event));

        this.currentValue = this.formElement.val();
    }

    onFieldSelect()
    {
        console.log('onFieldSelect');
        this.currentValue = this.formElement.val();

        /*
        if(this.isOpen)
            this.closeDropDown();
        else
            this.openDropDown();*/
    }

    onFieldChange()
    {
        console.log('onFieldChange');
    }

    onFieldFocusIn()
    {
        this.signals.focusIn.dispatch();
    }

    onFieldFocusOut()
    {
        this.signals.focusOut.dispatch();
    }

    openDropDown()
    {
        console.log('open');
        this.formElement.attr('size', 7);
        this.htmlElement.css({
            'height': this.openHeight
        });
        this.formElement.addClass('p3-dropDown-open');
        this.isOpen = true;
    }

    closeDropDown()
    {
        console.log('close');
        this.formElement.attr('size', 1);
        this.htmlElement.css({
            'height': this.closedHeight
        });
        this.formElement.removeClass('p3-dropDown-open');
        this.isOpen = false;
    }
}